import React from "react";
import {
  StyledMapKey,
  Overview,
  Highlight,
  Legend,
  LegendItem,
  LegendIcon,
} from "./MapKey.styles";
import UpIcon from "./icon/up.svg";
import DownIcon from "./icon/down.svg";
import { Trans, useTranslation } from "react-i18next";

const MapKey = ({ children, averageHousePrice, ...rest }) => {
  const { t } = useTranslation();

  // Convert to 10ks
  const price = parseInt(averageHousePrice).toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 0,
  });

  return (
    <StyledMapKey data-testid="map-key" {...rest}>
      <Overview>
        {t("mapkey.averageHousePriceForWales")}{" "}
        <Highlight color="#007961">{price}</Highlight>
      </Overview>
      <Legend>
        <LegendItem>
          <LegendIcon src={UpIcon} />{" "}
          <Trans i18nKey="mapkey.annualGrowth">
            Annual<Highlight color="#007961"> growth</Highlight>
          </Trans>
        </LegendItem>
        <LegendItem>
          <LegendIcon src={DownIcon} />{" "}
          <Trans i18nKey="mapkey.annualDecline">
            Annual<Highlight color="#E4032C"> decline</Highlight>
          </Trans>
        </LegendItem>
      </Legend>
    </StyledMapKey>
  );
};

export default MapKey;
